module.exports = __webpack_public_path__ + "so.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/so.svg
// module id = 814
// module chunks = 0